import React from 'react';
import { MoreHorizontalIcon, MinusIcon, CircleIcon } from 'lucide-react';
export function MiniTopBar({
  title,
  transparent
}: {
  title?: string;
  transparent?: boolean;
}) {
  return <div className={`flex items-center justify-between px-4 pt-3 pb-2 ${transparent ? '' : 'bg-white'}`} data-id="element-63">
      <div className="text-base font-medium text-slate-800" data-id="element-64">{title}</div>
      <div className="flex items-center gap-1 bg-black/5 rounded-full px-2.5 py-1" data-id="element-65">
        <MoreHorizontalIcon size={16} className="text-slate-700" data-id="element-66" />
        <div className="w-px h-3 bg-slate-300" data-id="element-67" />
        <MinusIcon size={14} className="text-slate-700" data-id="element-68" />
        <CircleIcon size={14} className="text-slate-700 ml-1" data-id="element-69" />
      </div>
    </div>;
}